import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="order-2 lg:order-1">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              About VigorBuy Spreadsheet
            </span>

            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
              One Platform for Quality Products and Powerful Productivity Tools
            </h2>

            <p className="text-foreground-700 leading-relaxed mb-4">
              VigorBuy Spreadsheet is built on a simple philosophy: businesses and individuals deserve tools that just work. In the world of spreadsheets and business software, too much time gets wasted on setup, troubleshooting, and manual processes that should be automated. We exist to change that.
            </p>

            <p className="text-foreground-700 leading-relaxed mb-6">
              At the same time, VigorBuy Spreadsheet offers a curated product catalog covering Shoes, Hoodies, T-Shirts, Jackets, Accessories, and more. Our commitment to quality extends from the digital tools we provide to the physical products we deliver. Whether you are here for a powerful spreadsheet template or a great pair of sneakers, our promise is the same: quality, efficiency, and value.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/vigorbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all whitespace-nowrap"
              >
                Learn More
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-full border-2 border-background-300 text-foreground-700 hover:bg-background-200 transition-all whitespace-nowrap cursor-pointer"
              >
                Visit Store
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20modern%20clothing%20flat%20lay%20with%20premium%20sneakers%2C%20denim%20jacket%2C%20leather%20belt%2C%20minimalist%20watch%20on%20warm%20beige%20fabric%20background%2C%20clean%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20cream%20and%20neutral%20color%20palette&width=800&height=600&seq=about-img-02&orientation=landscape"
                alt="VigorBuy Spreadsheet - Product Showcase"
                className="w-full h-full object-cover rounded-2xl"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}